import React, { Component } from 'react';
import './Login.css';
import { Button } from 'react-bootstrap';
import Header from '../Header/Header.jsx';
import MonitorApi from '../../utils/MonitorApi';
var Translate   = require('react-translate-component');


function init(){
  MonitorApi.init();
}

class App extends Component {

  constructor(props) {
    super(props);
    init();
    this.state = {
      passwordIncorrect: false
    };
    this.verifyLogin = this.verifyLogin.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
  }

  verifyLogin(){
    if(this.state.username && this.state.password){
      MonitorApi.login(this.state.username, this.state.password)
        .then(function(){
          window.location.replace(location.origin);
        },function(){
          this.setState({passwordIncorrect: true});
        }.bind(this));
    }
  }

  handleUsernameChange (e){
    this.setState({username: e.target.value});
  }

  handlePasswordChange(e){
    this.setState({password: e.target.value});
  }


  render() {
    const passwordIncorrect = this.state.passwordIncorrect;
    const frameStyle = {
    };
    const errorStyle = {
      'color': 'red',
      'padding-top': '20px'
    };

    let errorMsg = null;
    if(passwordIncorrect){
      errorMsg = <div style={errorStyle}>Wrong username or password</div>
    }

    return (
      <div style={frameStyle}>
        <Header />
        <div className="col-xs-12 centerAll screen_size">
          <div className="loginBox">
              <div className="col-xs-12">
                <form id="login-form"
                      className="login-form">
                  <div className="form-group">
                    <input type="text"
                           className="form-control"
                           onChange={this.handleUsernameChange}
                           placeholder="login"
                           name="username"/>
                  </div>
                  <div className="form-group">
                    <input type="password"
                           className="form-control"
                           onChange={this.handlePasswordChange}
                           placeholder="password"
                           name="password"/>
                  </div>
                  <Button onClick={this.verifyLogin}
                          id="btn-login"
                          className="no_style login_button"> <Translate component='span' content={'watchdog.login.login'} />
                  </Button>
                  {errorMsg}
                </form>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;


/** WEBPACK FOOTER **
 ** ./src/components/Login/Login.jsx
 **/